export const UserRoles = {
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  NGO_ADMIN: 'ROLE_ADMIN',
};
